import { combineReducers } from "redux";
import { application } from "./reducers/application";
import { contentFlow } from "./reducers/content-flow";
import { recentItems } from "./reducers/recent-items";

const state = combineReducers({
    application,
    contentFlow,
    recentItems,
});

export default state;
